if (!customElements.get("collapsible-text")) {
    customElements.define(
      "collapsible-text",
      class CollapsibleText extends HTMLElement {
        constructor() {
          super();
        }
  
        connectedCallback() {
            this.button = this.querySelector('.read-more-btn')
            this.textContainer = this.querySelector('.reading-width--inline')
            this.text = this.querySelector('.crt__text')
            this.showTextContainer = this.showTextContainer.bind(this);


            this.addEventListeners();
        }

        showTextContainer(){
            const maxHeight = this.text.getBoundingClientRect().height + 100;
            this.textContainer.style.setProperty('--read-more-max-height', `${maxHeight}px`);
            this.textContainer.classList.add('section__block--open')
        }
  

        addEventListeners() {
            this.button.addEventListener('click', this.showTextContainer)
        }
        
        removeEventListeners() {
            this.button.removeEventListener('click', this.showTextContainer)
         
        }
  
        disconnectedCallback() {
          this.removeEventListeners();
        }
      },
    );
  }
  